import React from "react";

const Select = React.forwardRef(({ invalid = false, className = "", children, ...props }, ref) => (
  <select
    ref={ref}
    className={[
      "control-select w-full h-11 border-[1.5px] rounded-[var(--r-sm)] px-3 bg-[var(--panel)] text-[var(--ink)] text-[15px] font-body",
      "outline-none transition-[border-color,box-shadow] focus:border-[var(--accent)] focus:shadow-[0_0_0_3px_color-mix(in_srgb,var(--accent)_10%,transparent)]",
      invalid ? "border-[var(--danger)]" : "border-[var(--line-2)]",
      className,
    ].join(" ")}
    {...props}
  >
    {children}
  </select>
));

export default Select;
